"use strict";
var ko = require("knockout");
var $ = require("jquery");
var _ = require("lodash");
var moment = require("moment");
require("bootstrap-daterangepicker");
ko.bindingHandlers["dateRangePicker"] = {
    init: function (element, valueAccessor, allBindings) {
        var $container = $(element), options = valueAccessor();
        var startDateObs = options.start, endDateObs = options.end;
        if (!ko.observable(startDateObs) || !ko.observable(endDateObs)) {
            throw new Error("Please specify valid \"start\" and \"end\" parameters.");
        }
        var currentDate = moment().startOf("day");
        var currentDateEnd = moment().endOf("day");
        var startOfWeek = currentDate.clone().add(-6, "days");
        var startOfMonth = currentDate.clone().add(-30, "days");
        var pastMonthStart = startOfMonth.clone().add(-1, "months");
        var pastMonthEnd = startOfMonth.clone().add(-1, "days").endOf("day");
        var yearStart = currentDate.clone().add(-12, "months");
        var defaultOptions = {
            startDate: startDateObs(),
            endDate: endDateObs(),
            ranges: {
                'За неделю': [startOfWeek, currentDateEnd],
                'За месяц': [startOfMonth, currentDateEnd],
                'За прошлый месяц': [pastMonthStart, pastMonthEnd],
                'За год': [yearStart, currentDateEnd]
            },
            locale: {
                "format": "DD MMMM YYYY",
                "customRangeLabel": "За период",
                "applyLabel": "Показать",
                "cancelLabel": "Отмена"
            },
            linkedCalendars: false,
            opens: "center",
            buttonClasses: "btn",
            showDropdowns: true,
            applyClass: "btn-primary",
            parentEl: ".page-content"
        };
        var daterangepickerOptions = _.defaultsDeep(options.custom || {}, defaultOptions);
        $container.addClass("daterangepicker-container");
        var $span = $("<span/>", {
            "class": "text-caption"
        });
        $container.append("<i class=\"icon-calendar\"></i>", $span, "<b class=\"caret\"></b>");
        function formatCaptionText(startDate, endDate) {
            if (startDate.isSame(currentDate) && endDate.isSame(currentDateEnd)) {
                return "За сегодня";
            }
            if (startDate.isSame(startOfWeek) && endDate.isSame(currentDateEnd)) {
                return "За неделю";
            }
            if (startDate.isSame(startOfMonth) && endDate.isSame(currentDateEnd)) {
                return "За месяц";
            }
            if (startDate.isSame(pastMonthStart) && endDate.isSame(pastMonthEnd)) {
                return "За прошлый месяц";
            }
            if (startDate.isSame(yearStart) && endDate.isSame(currentDateEnd)) {
                return "За год";
            }
            if (startDate.year() !== endDate.year()) {
                return startDate.format("D MMMM YYYY") + " — " + endDate.format("D MMMM YYYY");
            }
            if (startDate.month() !== endDate.month()) {
                return startDate.format("D MMMM") + " — " + endDate.format("D MMMM YYYY");
            }
            return startDate.format("D") + " — " + endDate.format("D MMMM YYYY");
        }
        function callback(startDate, endDate, label) {
            if (label === void 0) { label = ""; }
            if (!moment.isMoment(startDate)) {
                startDate = moment(startDate);
            }
            if (!moment.isMoment(endDate)) {
                endDate = moment(endDate);
            }
            $span.html(formatCaptionText(startDate, endDate));
            if (!startDate.isSame(startDateObs())) {
                startDateObs(startDate);
            }
            if (!endDate.isSame(endDateObs())) {
                endDateObs(endDate);
            }
        }
        callback(startDateObs(), endDateObs());
        $container.daterangepicker(daterangepickerOptions, callback);
        var drp = $container.data("daterangepicker");
        startDateObs.subscribe(function (newValue) {
            drp.setStartDate(newValue);
            callback(newValue, endDateObs());
        });
        endDateObs.subscribe(function (newValue) {
            drp.setEndDate(newValue);
            callback(startDateObs(), newValue);
        });
    }
};
//# sourceMappingURL=ko.dateRangePicker.js.map